import axios from "axios";

export const getMyProjects = async (
  page: number,
  limit: number,
  status?: string
) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("No token found");

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_URL}/projects/list/my-projects`,
      {
        headers: { Authorization: `Bearer ${token}`, "X-Client-Type": "web" },
        params: {
          page,
          limit,
          ...(status && status !== "all" ? { status } : {}),
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw new Error("Failed to fetch projects: " + error.message);
  }
};

export const getUserProjects = async (
  userId: number,
  page: number,
  limit: number,
  excludedStatuses?: string
) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("No token found");

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_URL}/projects/list/user-projects/${userId}`,
      {
        headers: { Authorization: `Bearer ${token}`, "X-Client-Type": "web" },
        params: {
          page,
          limit,
          ...(excludedStatuses && excludedStatuses.length > 0
            ? { excludedStatuses }
            : {}),
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw new Error("Failed to fetch projects: " + error.message);
  }
};

export const getProjectById = async (projectId: number) => {
  try {
    const token = localStorage.getItem("token");
    const res = await axios.get(
      `${process.env.REACT_APP_URL}/projects/${projectId}`,
      { headers: { Authorization: `Bearer ${token}`, "X-Client-Type": "web" } }
    );

    return { data: res.data, error: null };
  } catch (error: any) {
    return { error: error.response?.data, data: null };
  }
};

export const getDocumentPresignedUrl = async (documentId: string | number) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(
      `${process.env.REACT_APP_URL}/projects/documents/${documentId}`,
      { headers: { Authorization: `Bearer ${token}`, "X-Client-Type": "web" } }
    );
    return { data: response.data, error: null };
  } catch (error: any) {
    return { data: null, error };
  }
};

export const getSubtaskDocumentPresignedUrl = async (
  documentId: string | number
) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(
      `${process.env.REACT_APP_URL}/project-subtasks/documents/${documentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-Client-Type": "web",
        },
      }
    );
    return { data: response.data, error: null };
  } catch (error: any) {
    return { data: null, error };
  }
};
